(() => {
  const OPTION_NAME = "Color"; // must match your option name
  const norm = (v) => (v || "").toString().trim().toLowerCase();

  function matchesOptionLabel(text) {
    return norm(text).includes(norm(OPTION_NAME));
  }

  function getSelectedColor(productInfoEl) {
    // Swatch/radio version
    const fieldsets = productInfoEl.querySelectorAll("fieldset");
    for (const fs of fieldsets) {
      const legend = fs.querySelector("legend");
      if (legend && matchesOptionLabel(legend.textContent)) {
        const checked = fs.querySelector('input[type="radio"]:checked');
        if (!checked) return null;

        // Most themes: value is the option value (ex: "Floral")
        let val = checked.value;

        // Fallback: some themes store value as id, and display text in label
        if (!val || /^\d+$/.test(String(val))) {
          const label = fs.querySelector(`label[for="${checked.id}"]`);
          if (label) val = label.textContent;
        }

        return val ? val.trim() : null;
      }
    }

    // Dropdown version
    const selects = productInfoEl.querySelectorAll("select");
    for (const sel of selects) {
      const label = productInfoEl.querySelector(`label[for="${sel.id}"]`);
      if (label && matchesOptionLabel(label.textContent)) {
        return sel.value ? sel.value.trim() : null;
      }
    }

    return null;
  }

  function getVisibleSlides(mediaGalleryEl) {
    return Array.from(
      mediaGalleryEl.querySelectorAll(".product__media-item[data-media-id]")
    ).filter((el) => el.style.display !== "none");
  }

  function getActiveSlide(mediaGalleryEl, visibleSlides) {
    const currentId = mediaGalleryEl.dataset.onwrdActiveMediaId;
    if (currentId) {
      const match = visibleSlides.find(
        (el) => String(el.getAttribute("data-media-id")) === String(currentId)
      );
      if (match) return match;
    }

    return (
      visibleSlides.find((el) => el.classList.contains("is-active")) ||
      visibleSlides[0] ||
      null
    );
  }

  function patchSetActiveMedia(mediaGalleryEl) {
    if (mediaGalleryEl.dataset.onwrdPatchedSetActive === "true") return;
    if (typeof mediaGalleryEl.setActiveMedia !== "function") return;

    mediaGalleryEl.dataset.onwrdPatchedSetActive = "true";

    const original = mediaGalleryEl.setActiveMedia.bind(mediaGalleryEl);
    mediaGalleryEl.setActiveMedia = (mediaId, prepend) => {
      mediaGalleryEl.dataset.onwrdActiveMediaId = String(mediaId);
      return original(mediaId, prepend);
    };

    const initialActive = mediaGalleryEl.querySelector(
      ".product__media-item.is-active[data-media-id]"
    );
    if (initialActive) {
      mediaGalleryEl.dataset.onwrdActiveMediaId = String(
        initialActive.getAttribute("data-media-id")
      );
    }
  }

  function replaceWithClone(el) {
    const clone = el.cloneNode(true);
    el.parentNode.replaceChild(clone, el);
    return clone;
  }

  function wireChevronOverride(mediaGalleryEl) {
    if (mediaGalleryEl.dataset.onwrdChevronWired === "true") return;
    mediaGalleryEl.dataset.onwrdChevronWired = "true";

    patchSetActiveMedia(mediaGalleryEl);

    const viewerSlider =
      mediaGalleryEl.querySelector(
        `slider-component#GalleryViewer-${mediaGalleryEl.id.replace(
          "MediaGallery-",
          ""
        )}`
      ) || mediaGalleryEl.querySelector("slider-component");

    if (!viewerSlider) return;

    let prevBtn = viewerSlider.querySelector(".slider-button--prev");
    let nextBtn = viewerSlider.querySelector(".slider-button--next");
    if (!prevBtn || !nextBtn) return;

    prevBtn = replaceWithClone(prevBtn);
    nextBtn = replaceWithClone(nextBtn);

    const go = (dir) => {
      const visible = getVisibleSlides(mediaGalleryEl);
      if (visible.length <= 1) return;

      const active = getActiveSlide(mediaGalleryEl, visible);
      if (!active) return;

      const idx = Math.max(0, visible.indexOf(active));
      const nextIdx =
        dir === "next"
          ? (idx + 1) % visible.length
          : (idx - 1 + visible.length) % visible.length;

      const targetId = visible[nextIdx].getAttribute("data-media-id");
      if (targetId && typeof mediaGalleryEl.setActiveMedia === "function") {
        mediaGalleryEl.setActiveMedia(targetId, false);
      }
    };

    nextBtn.addEventListener("click", (e) => {
      e.preventDefault();
      go("next");
    });

    prevBtn.addEventListener("click", (e) => {
      e.preventDefault();
      go("prev");
    });
  }

  function refreshThumbUI(mediaGalleryEl) {
    const thumbsSlider = mediaGalleryEl.querySelector(
      "slider-component.thumbnail-slider"
    );
    if (!thumbsSlider) return;

    const track =
      thumbsSlider.querySelector(".thumbnail-list") ||
      thumbsSlider.querySelector("ul");

    try {
      if (typeof thumbsSlider.initPages === "function") thumbsSlider.initPages();
      if (typeof thumbsSlider.updateButtons === "function")
        thumbsSlider.updateButtons();
    } catch (e) {}

    if (track) {
      const x = track.scrollLeft;
      track.scrollLeft = x + 1;
      track.scrollLeft = x;

      track.dispatchEvent(new Event("scroll", { bubbles: true }));
    }

    window.dispatchEvent(new Event("resize"));
  }

  function filterMedia(mediaGalleryEl, selectedColor) {
    if (!mediaGalleryEl || !selectedColor) return;

    const wanted = norm(selectedColor);

    const slides = mediaGalleryEl.querySelectorAll(
      ".product__media-item[data-media-id]"
    );
    const thumbs = mediaGalleryEl.querySelectorAll(".thumbnail-list__item");

    let firstVisibleMediaId = null;

    slides.forEach((slide) => {
      const color = norm(slide.getAttribute("data-color"));
      const isUniversal = color === "";
      const matches = isUniversal || color === wanted;

      slide.style.display = matches ? "" : "none";

      if (matches && !firstVisibleMediaId) {
        firstVisibleMediaId = slide.getAttribute("data-media-id");
      }
    });

    thumbs.forEach((thumb) => {
      const color = norm(thumb.getAttribute("data-color"));
      const isUniversal = color === "";
      const matches = isUniversal || color === wanted;

      thumb.style.display = matches ? "" : "none";
    });

    if (
      typeof mediaGalleryEl.setActiveMedia === "function" &&
      firstVisibleMediaId
    ) {
      const visibleNow = getVisibleSlides(mediaGalleryEl);

      const currentId =
        mediaGalleryEl.dataset.onwrdActiveMediaId ||
        mediaGalleryEl
          .querySelector(".product__media-item.is-active[data-media-id]")
          ?.getAttribute("data-media-id");

      const currentIsVisible =
        currentId &&
        visibleNow.some(
          (el) => el.getAttribute("data-media-id") === String(currentId)
        );

      if (!currentIsVisible) {
        mediaGalleryEl.setActiveMedia(firstVisibleMediaId, false);
      }
    }

    refreshThumbUI(mediaGalleryEl);
  }

  function apply(productInfoEl) {
    const mediaGalleryEl = productInfoEl.querySelector("media-gallery");
    if (!mediaGalleryEl) return;

    wireChevronOverride(mediaGalleryEl);

    const selectedColor = getSelectedColor(productInfoEl);
    if (!selectedColor) return;

    filterMedia(mediaGalleryEl, selectedColor);
  }

  function init() {
    document.querySelectorAll("product-info").forEach((productInfoEl) => {
      apply(productInfoEl);

      productInfoEl.addEventListener("change", (e) => {
        if (e.target.matches('input[type="radio"], select')) {
          apply(productInfoEl);
        }
      });

      document.addEventListener("variant:change", () => apply(productInfoEl));
    });
  }

  document.addEventListener("DOMContentLoaded", init);
})();